import React from 'react';

import { styled } from '@mui/material';

type Props = {
  subline: string;
  icon: React.ReactNode;
  headline: string;
  text: string;
};

export const ServiceTileTeaser = ({ subline, icon, headline, text }: Props) => {
  return (
    <Container>
      <Subline>{subline}</Subline>
      <IconBox>{icon}</IconBox>
      <Headline>{headline}</Headline>
      <Text>{text}</Text>
    </Container>
  );
};

export default ServiceTileTeaser;

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 'var(--spacer-m) 20px',
}));

const IconBox = styled('div')(({ theme }) => ({
  width: '64px',
  height: '64px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.up('md')]: {
    width: '128px',
    height: '128px',
  },
}));

const Subline = styled('p')(({ theme }) => ({
  ...theme.typography.body,
  margin: '0 0 var(--spacer-m) 0',
  fontWeight: theme.typography.fontWeightMedium,
}));

const Headline = styled('h4')(({ theme }) => ({
  ...theme.typography.h4,
  margin: '0 0 var(--spacer-m) 0',
}));

const Text = styled('p')(({ theme }) => ({
  ...theme.typography.body,
  margin: 0,
}));
